import styled from "styled-components";
import { NEGATIVE_AMOUNT_COLOR, statusColors } from "./statusPalette";

export const DesktopPage = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;



export const DesktopTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #293142;
  margin: 0;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #293142;
  margin: 0;
`;

export const PaymentAdviceButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #fff5f6;
  color: #ef4f5f;
  border: 1px solid #ef4f5f;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CellText = styled.span`
  font-size: 14px;
  color: #293142;
`;

export const AmountCell = styled.span`
  font-size: 14px;
  color: ${(props) => (props.$negative ? NEGATIVE_AMOUNT_COLOR : "#293142")};
`;

export const LinkCell = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #293142;
  text-decoration: underline;
  text-decoration-style: dotted;
  white-space: nowrap;
`;

export const CopyIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  padding: 0;
  margin-left: 6px;
  color: #767c8f;
  cursor: pointer;

  &:hover {
    color: #293142;
  }
`;

export const StatusPill = styled.span`
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => statusColors(props.$status).bg};
  color: ${(props) => statusColors(props.$status).fg};
`;

export const DrawerScreen = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export {
  FiltersCard,
  FiltersTitle,
  FiltersRow,
  FilterField,
  FilterLabel,
  FiltersActions,
  ApplyFiltersButton,
  ClearAllButton,
} from "components/shared/TableWithFilters/styles.tableWithFilters";
